import { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { setRecaptchaExecutor } from './recaptchaService';

/**
 * Componente sin UI. Debe montarse dentro de <GoogleReCaptchaProvider>.
 * Registra la función `executeRecaptcha` en recaptchaService para que la capa
 * de red pueda generar tokens frescos por request.
 */
const RecaptchaBinder = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    setRecaptchaExecutor(executeRecaptcha || null);
    return () => setRecaptchaExecutor(null);
  }, [executeRecaptcha]);

  return null;
};

export default RecaptchaBinder;
